import { printStackTrace18lnx7a39cni as printStackTrace } from '../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { plus310ted5e4i90h as plus } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  OnField23al9ljlbymf9 as OnField,
  IfNotNull13ixxkuz43ozs as IfNotNull,
} from '../lightningdb/Condition.mjs';
import {
  OnFieldsnrykjjrmtcs as OnField_0,
  IfNotNull2i0zh8hr8em4r as IfNotNull_0,
} from '../lightningdb/Modification.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { DataClassPathSerializer1pr4zwqha0dv8 as DataClassPathSerializer } from './DataClassPathSerializer.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { nullElementzitp7se36veh as nullElement } from './SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DataClassPathAccessClass;
function DataClassPathAccess() {
  if (DataClassPathAccessClass === VOID) {
    class $ extends DataClassPath() {
      constructor(first, second) {
        super();
        this.k4q_1 = first;
        this.l4q_1 = second;
      }
      p3(key) {
        var tmp0_safe_receiver = this.k4q_1.p3(key);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_0;
          try {
            tmp_0 = this.l4q_1.m2j(tmp0_safe_receiver);
          } catch ($p) {
            var tmp_1;
            if ($p instanceof Exception()) {
              var e = $p;
              printStackTrace(e);
              throw IllegalArgumentException().zd('Could not get ' + this.l4q_1.k20() + ' on ' + toString(tmp0_safe_receiver), e);
            } else {
              throw $p;
            }
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      m4q(key, value) {
        var tmp0_safe_receiver = this.k4q_1.p3(key);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = this.k4q_1.m4q(key, this.l4q_1.p2j(tmp0_safe_receiver, value));
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? key : tmp1_elvis_lhs;
      }
      toString() {
        var tmp;
        var tmp_0 = this.k4q_1;
        if (tmp_0 instanceof DataClassPathSelf()) {
          tmp = this.l4q_1.k20();
        } else {
          tmp = this.k4q_1.toString() + '.' + this.l4q_1.k20();
        }
        return tmp;
      }
      n4q() {
        return plus(this.k4q_1.n4q(), listOf(this.l4q_1));
      }
      m3t(condition) {
        return this.k4q_1.m3t(OnField().h3t(this.l4q_1, condition));
      }
      f44(modification) {
        return this.k4q_1.f44(OnField_0().c44(this.l4q_1, modification));
      }
      j2j() {
        return this.l4q_1.j2j();
      }
      hashCode() {
        var result = this.k4q_1.hashCode();
        result = imul(result, 31) + hashCode(this.l4q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DataClassPathAccess()))
          return false;
        if (!this.k4q_1.equals(other.k4q_1))
          return false;
        if (!equals(this.l4q_1, other.l4q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DataClassPathAccess');
    DataClassPathAccessClass = $;
  }
  return DataClassPathAccessClass;
}
var DataClassPathSelfClass;
function DataClassPathSelf() {
  if (DataClassPathSelfClass === VOID) {
    class $ extends DataClassPath() {
      constructor(serializer) {
        super();
        this.o4q_1 = serializer;
      }
      j2j() {
        return this.o4q_1;
      }
      p3(key) {
        return key;
      }
      p4q(key, value) {
        return value;
      }
      m4q(key, value) {
        var tmp = (key == null ? true : !(key == null)) ? key : THROW_CCE();
        return this.p4q(tmp, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
      toString() {
        return 'this';
      }
      hashCode() {
        return 0;
      }
      equals(other) {
        return other instanceof DataClassPathSelf();
      }
      n4q() {
        // Inline function 'kotlin.collections.listOf' call
        return emptyList();
      }
      q4q(condition) {
        return condition;
      }
      m3t(condition) {
        return this.q4q(condition);
      }
      r4q(modification) {
        return modification;
      }
      f44(modification) {
        return this.r4q(modification);
      }
    }
    initMetadataForClass($, 'DataClassPathSelf');
    DataClassPathSelfClass = $;
  }
  return DataClassPathSelfClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      n3k(typeSerial0) {
        return new (DataClassPathSerializer())(typeSerial0);
      }
      h1c(typeParamsSerializers) {
        return this.n3k(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var DataClassPathPartialClass;
function DataClassPathPartial() {
  if (DataClassPathPartialClass === VOID) {
    class $ {}
    initMetadataForClass($, 'DataClassPathPartial', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    DataClassPathPartialClass = $;
  }
  return DataClassPathPartialClass;
}
var DataClassPathClass;
function DataClassPath() {
  if (DataClassPathClass === VOID) {
    class $ extends DataClassPathPartial() {
      s4a(key) {
        return this.p3(key);
      }
      prop(prop) {
        return new (DataClassPathAccess())(this, prop);
      }
      t4a() {
        return this.j2j();
      }
    }
    initMetadataForClass($, 'DataClassPath');
    DataClassPathClass = $;
  }
  return DataClassPathClass;
}
var DataClassPathNotNullClass;
function DataClassPathNotNull() {
  if (DataClassPathNotNullClass === VOID) {
    class $ extends DataClassPath() {
      constructor(wraps) {
        super();
        this.s4q_1 = wraps;
      }
      n4q() {
        return this.s4q_1.n4q();
      }
      p3(key) {
        return this.s4q_1.p3(key);
      }
      m4q(key, value) {
        return this.s4q_1.m4q(key, value);
      }
      toString() {
        return this.s4q_1.toString() + '?';
      }
      m3t(condition) {
        return this.s4q_1.m3t(IfNotNull().k3t(condition));
      }
      f44(modification) {
        return this.s4q_1.f44(IfNotNull_0().l42(modification));
      }
      j2j() {
        var tmp = ensureNotNull(nullElement(this.s4q_1.j2j()));
        return isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
      }
      hashCode() {
        return this.s4q_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DataClassPathNotNull()))
          return false;
        if (!this.s4q_1.equals(other.s4q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DataClassPathNotNull');
    DataClassPathNotNullClass = $;
  }
  return DataClassPathNotNullClass;
}
function get_notNull(_this__u8e3s4) {
  return new (DataClassPathNotNull())(_this__u8e3s4);
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  DataClassPathAccess as DataClassPathAccess21fi12r1lk4vq,
  DataClassPathNotNull as DataClassPathNotNullyxwowc5mmyv5,
  DataClassPathPartial as DataClassPathPartial2s3bzp98w5uo7,
  DataClassPathSelf as DataClassPathSelf9694s3fei65z,
  DataClassPath as DataClassPath3joljqmfaqhxf,
  get_notNull as get_notNull2xk5v9at1ay9v,
  Companion_instance as Companion_instance1kjus4hvx4qjx,
};
//endregion

//# sourceMappingURL=DataClassPath.mjs.map
